import { SHA3 } from 'sha3';
import { setToken, clearToken } from './TokenService';
import api from './api';

export async function authenticate(username, password) {
  const response = await api.post('/authenticate', {
    u: username,
    p: new SHA3(256).update(password).digest('hex'),
  });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.jwt;
}

export async function validateToken(token) {
  const response = await api.post('/validateToken', { jwt: token });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

// Boundary function — returns boolean so callers that haven't been
// refactored yet (NavigationBar) still work. Will be cleaned up in Task 4.
export async function handleToken(token) {
  try {
    await validateToken(token);
    setToken(token);
    return true;
  } catch {
    clearToken();
    return false;
  }
}

export function handleLogout() {
  clearToken();
}
